import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAppoinmentAction,
  getAppointmentQueueFilterCountsAction,
  getClientNameAction,
  getExportAppoinmentExcelAction,
  getProviderNameAction,
} from "../../../redux/actions/AppoinmentAction";
import Select from "react-select";
import Modal from "react-modal";
import {
  initialStateFilter,
  IbuExcelHeader,
  CSVData,
  selectOptionStatus,
  IbuExcelNetworkHeader,
  PrintDropdownDetails,
} from "./helper";
import {
  clearCurrentPage,
  getApiParams,
  updateDurationDate,
} from "../../NetworkPortal/ProviderProfileDetails/helper";
import _debounce from "lodash/debounce";
import { useCallback } from "react";
import AppoinmentDateRangePicker from "./AppoinmentDateRangePicker";
import { CSVLink } from "react-csv";
import { MERLibraryPopup } from "./MERLibraryPopup";
import { FunnelBox, FunnelBoxDetail } from "./FunnelBox";
import AppointmentCardContainer from "./AppointmentCardContainer";
import { ExcelIcon, MerLibraryIcon } from "../../../Utils/SvgIcons";
import { getRole } from "../../../Utils/types";
import { isLoadingAction } from "../../../Utils/helper";

const Appoinments = () => {
  const dispatch = useDispatch();
  const [multiSelect, setMultiSelect] = useState([]);
  const [searchFilter, setSearchFilter] = useState(initialStateFilter);
  const [openMerpopup, setOpenMerpopup] = useState(false);
  const [isShowFilter, setIsShowFilter] = useState(true);
  const [excelSheetData, setExcelSheetData] = useState([]);
  const [funnelSelected, setFunnelSelected] = useState("todayAppointment");
  const globalReducer = useSelector((state) => state?.globalReducer);
  const { apiParams } = getApiParams({ globalReducer });

  const appoinmentReducer = useSelector((state) => state?.AppoinmentReducer);
  const getAppoinmentDetail = appoinmentReducer?.getAppoinmentDetail;

  const debounceProvider = useCallback(
    _debounce(handleDebounceProvider, 1000),
    []
  );
  const debounceClient = useCallback(_debounce(handleDebounceClient, 1000), []);
  useEffect(() => {
    updateDurationDate(
      dispatch,
      initialStateFilter?.fromDate,
      initialStateFilter?.toDate
    );
    dispatch(getAppointmentQueueFilterCountsAction(initialStateFilter));
  }, []);

  useEffect(() => {
    if (!openMerpopup) {
      dispatch(
        getAppoinmentAction({
          ...searchFilter,
          page: globalReducer?.getCurrentPage,
        })
      );
    }
  }, [globalReducer?.getCurrentPage, openMerpopup]);

  const changeHandler = (name, value) => {
    setSearchFilter({ ...searchFilter, [name]: value });
  };

  const handleSearch = () => {
    dispatch(getAppoinmentAction({ ...searchFilter, ...apiParams, page: 1 }));
    dispatch(
      getAppointmentQueueFilterCountsAction({
        ...searchFilter,
        ...apiParams,
        page: 1,
      })
    );
    clearCurrentPage(dispatch);
    setMultiSelect([]);
  };

  const handleSorting = async (type) => {
    await clearCurrentPage(dispatch);
    await changeHandler("sortDirection", type);
    await dispatch(
      getAppoinmentAction({
        ...searchFilter,
        sortDirection: type,
      })
    );
  };

  const handleClearFilter = async () => {
    await setSearchFilter(initialStateFilter);
    dispatch(getAppoinmentAction(initialStateFilter));
    dispatch(getAppointmentQueueFilterCountsAction(initialStateFilter));
    await updateDurationDate(
      dispatch,
      initialStateFilter?.fromDate,
      initialStateFilter?.toDate
    );
    await clearCurrentPage(dispatch);
    await setFunnelSelected("todayAppointment");
    await setMultiSelect([]);
  };

  function handleDebounceClient(inputValue) {
    dispatch(getClientNameAction(inputValue));
  }

  function handleDebounceProvider(inputValue) {
    dispatch(getProviderNameAction(inputValue));
  }

  const ExportToExcelHandler = async () => {
    isLoadingAction(true, dispatch);
    const resp = dispatch(
      getExportAppoinmentExcelAction({ ...searchFilter, flag: "Y" })
    );
    resp?.then((res) => {
      if (res?.data?.status === true) {
        if (getRole() === "NetworkAdmin") {
          setExcelSheetData(res?.data?.results?.apointmentmanagementList);
          isLoadingAction(false, dispatch);
        } else {
          setExcelSheetData(res?.data?.results?.apointmentQueueList);
          isLoadingAction(false, dispatch);
        }
      }
      setTimeout(() => {
        document.getElementById("exportexcel").click();
      }, 500);
    });
  };

  return (
    <div className="right-section">
      <div className="appoinment-sec">
        <div className="row">
          <div className="col-lg-12 col-12">
            <h1> Your Appointments Dashboard</h1>
          </div>
          {FunnelBoxDetail?.map((ele, index) => {
            return (
              <FunnelBox
                key={index}
                heading={ele?.heading}
                count={
                  appoinmentReducer?.getAppointmentCount?.[ele?.funnelType]
                }
                selectedFunnel={funnelSelected === ele?.funnelType}
                searchFilter={searchFilter}
                setFunnelSelected={setFunnelSelected}
                type={ele?.funnelType}
                setMultiSelect={setMultiSelect}
                setSearchFilter={setSearchFilter}
                data={{
                  ...initialStateFilter,
                  providerId: searchFilter?.providerId,
                  providerName: searchFilter?.providerName,
                  status: ele?.status,
                  fromDate: ele?.fromDate,
                  toDate: ele?.toDate,
                }}
              />
            );
          })}
          <h1 className="pt-4">
            Filters &nbsp;
            <i
              className={isShowFilter ? "fa fa-angle-up" : "fa fa-angle-down"}
              onClick={() =>
                setIsShowFilter(isShowFilter ? false : !isShowFilter && true)
              }
            ></i>
          </h1>
          <div className={`${isShowFilter ? "row" : "isHideFilter"}`}>
            <div className="mb-3 col-lg-3">
              <input
                type="text"
                className="form-control"
                placeholder=" Case ID / Policy No."
                value={
                  searchFilter?.caseNo === null ? "" : searchFilter?.caseNo
                }
                onChange={(e) => changeHandler("caseNo", e.target.value)}
              />
            </div>
            {getRole() === "NetworkAdmin" && (
              <div className="mb-3 col-lg-3">
                <Select
                  placeholder="Provider Name"
                  className="basic-multi-select"
                  classNamePrefix="select"
                  name="colors"
                  isClearable={true}
                  options={appoinmentReducer?.getProviderNameDetails?.map(
                    (ele) => {
                      return {
                        value: ele?.providerId,
                        label: ele?.providerName,
                      };
                    }
                  )}
                  onInputChange={(e) => {
                    if (e !== "") {
                      debounceProvider(e);
                    }
                  }}
                  onChange={(e) => {
                    setSearchFilter({
                      ...searchFilter,
                      providerId: e === null ? 0 : e?.value,
                      providerName: e === null ? e : e?.label,
                    });
                  }}
                  value={
                    searchFilter?.providerName === null
                      ? ""
                      : {
                          value: searchFilter?.providerId,
                          label: searchFilter?.providerName,
                        }
                  }
                />
              </div>
            )}
            <div className="mb-3 col-lg-3">
              <Select
                placeholder="Client Name"
                className="basic-multi-select"
                classNamePrefix="select"
                name="colors"
                options={appoinmentReducer?.getClientNameDetails?.map((ele) => {
                  return {
                    value: ele?.clientName,
                    label: ele?.clientName,
                  };
                })}
                onInputChange={(e) => {
                  if (e !== "") {
                    debounceClient(e);
                  }
                }}
                onChange={(e) => {
                  setSearchFilter({
                    ...searchFilter,
                    clientName: e === null ? e : e?.value,
                  });
                }}
                isClearable={true}
                value={
                  searchFilter?.clientName === null
                    ? ""
                    : {
                        value: searchFilter?.clientName,
                        label: searchFilter?.clientName,
                      }
                }
              />
            </div>
            <div className="mb-3 col-lg-3">
              <input
                type="text"
                className="form-control"
                placeholder=" Customer Name"
                value={
                  searchFilter?.customerName === null
                    ? ""
                    : searchFilter?.customerName
                }
                onChange={(e) => changeHandler("customerName", e.target.value)}
              />
            </div>
            <div className="mb-3 col-lg-3">
              <input
                type="text"
                className="form-control"
                minLength={10}
                maxLength={10}
                placeholder="Mobile Number"
                value={
                  searchFilter?.mobileNumber === null
                    ? ""
                    : searchFilter?.mobileNumber
                }
                onChange={(e) => changeHandler("mobileNumber", e.target.value)}
                onKeyPress={(event) => {
                  const re = /[0-9]+/g;
                  if (!re.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
            </div>
            <div className="mb-3 col-lg-4">
              <Select
                placeholder="Select Status"
                className="basic-multi-select"
                classNamePrefix="select"
                isMulti
                closeMenuOnSelect={false}
                name="colors"
                onChange={(event) =>
                  changeHandler("status", event.map((e) => e.value).toString())
                }
                options={selectOptionStatus}
                value={
                  searchFilter?.status === "" || searchFilter?.status === null
                    ? null
                    : searchFilter?.status?.split(",")?.map((e) => ({
                        value: e,
                        label:
                          e === "A"
                            ? "Accepted"
                            : e === "R"
                            ? "Rejected"
                            : e === "P"
                            ? "Pending"
                            : e === "S"
                            ? "Report Pending"
                            : e === "U"
                            ? "Completed"
                            : e === "N"
                            ? "No Show"
                            : e === "E"
                            ? "Expired"
                            : e === "C"
                            ? "Cancelled"
                            : e === "H"
                            ? "Report On Hold" 
                            : e === "Z" 
                            ? "Partial Show"
                            : e === "K" && "Confirmed",
                      }))
                }
              />
            </div>
            <div className="mb-3 col-lg-4">
              <AppoinmentDateRangePicker
                searchFilter={searchFilter}
                setSearchFilter={setSearchFilter}
              />
            </div>
            <div className="mb-3 col-lg-4" style={{ display: "flex" }}>
              <button
                className="btn btn-primary me-2"
                style={{ fontSize: "16px" }}
                type="button"
                onClick={handleSearch}
              >
                Search
              </button>
              <button
                className="btn btn-primary me-2"
                style={{ fontSize: "16px" }}
                type="button"
                onClick={handleClearFilter}
              >
                Clear
              </button>
              <button
                className="btn btn-primary me-2"
                style={{ fontSize: "16px" }}
                type="button"
                onClick={handleSearch}
              >
                Refresh
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="results-sortby">
        <div className="d-flex gap-10 align-items-center m-gap">
          <select
            className="row-selectdropdown"
            value={searchFilter?.rows}
            onChange={(e) => {
              setSearchFilter({
                ...searchFilter,
                rows: e.target.value,
              });
              dispatch(
                getAppoinmentAction({
                  ...searchFilter,
                  rows: e.target.value,
                  ...apiParams,
                  page: 1,
                })
              );
            }}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
          </select>
          <div className="results d-flex gap-1">
            Total <span>{getAppoinmentDetail?.totalRow}</span> results
          </div>
        </div>
        <div className="d-flex align-items-center gap-5">
          <div className="appointment-action-btns">
            <div className="action-button">
              <button
                className="dropdown-toggle appointment-dropdown"
                type="button"
                id="dropdownMenu3"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{ minWidth: "auto" }}
              >
                <span>Print</span>
                <img
                  style={{
                    width: "12px",
                    height: "12px",
                    marginRight: "10px",
                    cursor: "pointer",
                  }}
                  src="./images/arrowDownWhite.png"
                />
              </button>
              <ul
                className="dropdown-menu"
                aria-labelledby="dropdownMenu3"
                style={{ paddingBottom: "0px" }}
              >
                {PrintDropdownDetails?.map((ele, index) => {
                  const dataToSend = {
                    ...initialStateFilter,
                    flag: "Y",
                    status: ele?.status,
                    fromDate: ele?.fromDate,
                    toDate: ele?.toDate,
                    FilterPresetName: ele?.funnelType,
                  };
                  const queryString = Object.keys(dataToSend)
                    .map(
                      (key) =>
                        `${encodeURIComponent(key)}=${encodeURIComponent(
                          dataToSend[key]
                        )}`
                    )
                    .join("&");
                  return (
                    <li key={index}>
                      <a
                        href={`/ProvidersPortal/appointmentdetailstemplate/${queryString}`}
                        target="_blank"
                        className="dropdown-item btn-border-bottom"
                      >
                        {ele?.heading}
                      </a>
                    </li>
                  );
                })}
              </ul>
              <a
                className="export-to-excel"
                style={{ cursor: "pointer" }}
                type="button"
                onClick={ExportToExcelHandler}
              >
                <span style={{ color: "white" }}>Export to Excel</span>
                <ExcelIcon />
              </a>
              <CSVLink
                style={{ display: "none" }}
                id="exportexcel"
                data={CSVData(excelSheetData)}
                headers={
                  getRole() === "NetworkAdmin"
                    ? IbuExcelNetworkHeader
                    : IbuExcelHeader
                }
                filename={"appointments.csv"}
              ></CSVLink>
              <a
                className="export-to-excel"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setOpenMerpopup(true);
                  clearCurrentPage(dispatch);
                }}
              >
                <span style={{ color: "white" }}>MER Library</span>
                <MerLibraryIcon />
              </a>
              <button
                className="dropdown-toggle appointment-dropdown"
                type="button"
                id="dropdownMenu2"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span>
                  {searchFilter?.sortDirection === "asc"
                    ? "Oldest to Latest"
                    : "Latest to Oldest"}
                </span>
                <i className="fa fa-list"></i>
              </button>
              <ul className="dropdown-menu" aria-labelledby="dropdownMenu2">
                <li>
                  <button
                    className="dropdown-item btn-border-bottom"
                    type="button"
                    onClick={() => handleSorting("asc")}
                  >
                    Oldest to Latest
                  </button>
                </li>
                <li>
                  <button
                    className="dropdown-item"
                    type="button"
                    onClick={() => handleSorting("desc")}
                  >
                    Latest to Oldest
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <AppointmentCardContainer
        searchFilter={searchFilter}
        apiParams={apiParams}
        funnelSelected={funnelSelected}
        multiSelect={multiSelect}
        setMultiSelect={setMultiSelect}
      />
      {/*MER Library Popup */}
      <Modal
        isOpen={openMerpopup}
        className="modal-mer-popup"
        overlayClassName="overlay-mer-popup network-z-index"
        ariaHideApp={false}
      >
        <MERLibraryPopup setOpenMerpopup={setOpenMerpopup} />
      </Modal>
    </div>
  );
};

export default Appoinments;
